export const DEVICE_BREAKPOINTS = {
  small: 0,
  laptop: 1200, // tablets → laptops básicos
  medium: 1650, // 1600x900, 1680x1050
  large: 1850, // 1920x1080, 1920x1200
  xl: 2200, // ultrawide / 4K
};

export const getDeviceType = (width) => ({
  isSmall: width < DEVICE_BREAKPOINTS.laptop,
  isLaptop: width >= DEVICE_BREAKPOINTS.laptop && width < DEVICE_BREAKPOINTS.medium,
  isMedium: width >= DEVICE_BREAKPOINTS.medium && width < DEVICE_BREAKPOINTS.large,
  isLarge: width >= DEVICE_BREAKPOINTS.large && width < DEVICE_BREAKPOINTS.xl,
  isXL: width >= DEVICE_BREAKPOINTS.xl,
});
